import { useCallback, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import AddIcon from "@icons/myicons/plus.svg?react";
import BankIcon from "@icons/myicons/bank.svg?react";
import AddPortfolioModal from "@features/add/AddPortfolioModal";
import { addOptions } from "@features/add/AddPortfolio";
import { ImportType, ImportTypeRef } from "@features/add/components/types";
import {
  AdaptiveButton,
  ResponsiveDropdown,
  ResponsiveDropdownGroup,
} from "@components";
import { useNewTransactionActions } from "./useNewTransactionActions";

export const InvestmentsAddButton = () => {
  const { t } = useTranslation();
  const modalRef = useRef<ImportTypeRef | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const transactionItems = useNewTransactionActions();

  const onSelect = useCallback((val: ImportType) => {
    setIsModalOpen(true);
    modalRef.current?.setImportType(val);
  }, []);

  const groups: ResponsiveDropdownGroup[] = [
    {
      title: t("investmentsPage.header.actions.newDepot"),
      icon: <BankIcon width="18px" height="18px" />,
      items: addOptions.map((option) => ({
        label: t(option.text),
        testId: `${option.testId}-create`,
        onClick: () => onSelect(option as ImportType),
      })),
    },
    {
      title: t("investmentsPage.header.actions.main"),
      icon: <AddIcon width="18px" height="18px" />,
      items: transactionItems,
    },
  ];

  return (
    <>
      <ResponsiveDropdown
        mobileTitle={t("investmentsPage.header.actions.addTitle")}
        groups={groups}
        anchor={
          <AdaptiveButton
            iconOnly
            icon={<AddIcon width="16px" height="16px" />}
            label={t("investmentsPage.header.actions.addTitle")}
            testId="investments-add-button"
          />
        }
      />
      <AddPortfolioModal
        ref={modalRef}
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
      />
    </>
  );
};
